export default __webpack_public_path__ + "static/media/activity.bf45bc1b.svg";